export default __webpack_public_path__ + "static/media/reports.34c9f16a.svg";